import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Container from "@mui/material/Container";
import Stack from "components/common/Stack";
import Image from "components/common/Image";
import Text from "components/common/Text";
// import SentimentTrackerInfoContainer from "containers/ProductInfo/SentimentTrackerInfo";
import { localStore } from "stores/localStorage";
import { config } from "config/index";
import JarvisCard from "components/JarvisCard";
import JarvisButton from "components/JarvisButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Button from "components/common/Button";
import { withStyles } from "@mui/styles";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import TooltipHover from "components/common/TooltipHover";
import SentimentTrackerInfoContainer from "containers/ProductInfo/SentimentTrackerInfo/SentimentTrackerInfoContainer";

const sentimentTrackerProduct = {
  id: "sentimentTracker",
  name: "Jarvis F&O Sentiment Tracker",
  description:
    "To help you with short term recommendations and timely calls to book profits",
  icon: "/images/product-info/onestock-bag.svg",
  investNow: "",
  banner: "/images/product-info/portfolio.svg",
};

const Tabs = {
  portfolio: [
    {
      id: "portfolio_1",
      isActive: true,
      title: "Whom",
      img: "/images/product-info/whom.png",
      text: "For existing and new investors who don’t have the time and expertise to manage their portfolio",
    },
    {
      id: "portfolio_2",
      isActive: false,
      title: "Tenure",
      img: "/images/product-info/tenure.svg",
      text: "Between 4 to 5 years regardless of market condition",
    },
    {
      id: "portfolio_3",
      isActive: false,
      title: "Min. investment",
      img: "/images/product-info/min-inv.png",
      text: "Your demant account should have a minimum balance of Rs 30,000",
    },
    {
      id: "portfolio_4",
      isActive: false,
      title: "Benefits for you",
      img: "/images/product-info/benefits.png",
      text: "text update here",
    },
  ],
  prime: [
    {
      id: "prime_1",
      isActive: true,
      title: "Whom",
      img: "/images/product-info/whom.png",
      text: "For existing and new investors who don't have the time and expertise to manage their portfolio",
    },
    {
      id: "prime_2",
      isActive: false,
      title: "Tenure",
      img: "/images/product-info/tenure.svg",
      text: "Between 4 to 5 years regardless of market condition",
    },
    {
      id: "prime_3",
      isActive: false,
      title: "Min. investment",
      img: "/images/product-info/min-inv.png",
      text: "Your demant account should have a minimum balance of Rs 25,00,000",
    },
    {
      id: "prime_4",
      hasChipUI: true,
      isActive: false,
      title: "Benefits for you",
      img: "/images/product-info/benefits.png",
      text: [
        "AI-based stock selection",
        "Personalised portfolio",
        "Timely rebalancing",
        "24X7 risk management process",
        "No human error",
        "No human bias",
        "Ongoing stock recommendations",
        "Ease of transactions",
      ],
    },
  ],

  protect: [
    {
      id: "protect_1",
      isActive: true,
      title: "Whom",
      img: "/images/product-info/whom.png",
      text: "Investors with underperforming stocks portfolio and don't know what to do with it",
    },
    {
      id: "protect_2",
      isActive: false,
      title: "Tenure",
      img: "/images/product-info/tenure.svg",
      text: "There is no minimum tenure commitment required",
    },
    {
      id: "protect_3",
      isActive: false,
      title: "Min. investment",
      img: "/images/product-info/min-inv.png",
      text: "Your portfolio should have at least 5 stocks",
    },
    {
      id: "protect_4",
      isActive: false,
      title: "Benefits for you",
      img: "/images/product-info/benefits.png",
      text: "text update here",
    },
  ],
  onestock: [
    {
      id: "onestock_1",
      isActive: true,
      title: "Whom",
      img: "/images/product-info/whom.png",
      text: "To book short term profits with less capital",
    },
    {
      id: "onestock_2",
      isActive: false,
      title: "Tenure",
      img: "/images/product-info/tenure.svg",
      text: "The typical holding period for a stock might vary from 15 to 30 days",
    },
    {
      id: "onestock_3",
      isActive: false,
      title: "Min. investment",
      img: "/images/product-info/min-inv.png",
      text: "There is no minimum investment required",
    },
    {
      id: "onestock_4",
      hasChipUI: true,
      isActive: false,
      title: "Benefits for you",
      img: "/images/product-info/benefits.png",
      text: [
        "Short-term profit booking alerts",
        "Personalized stock recommendations",
        "AI-based stock selection",
        "24x7 risk management system",
        "No human bias & error",
      ],
    },
  ],

  sentimentTracker: [
    {
      id: "sentimentTracker_1",
      isActive: true,
      title: "Whom",
      img: "/images/product-info/whom.png",
      text: "To book short term profits with less capital",
    },
    {
      id: "sentimentTracker_2",
      isActive: false,
      title: "Tenure",
      img: "/images/product-info/tenure.svg",
      text: "The typical holding period for a stock might vary from 15 to 30 days",
    },
    {
      id: "sentimentTracker_3",
      isActive: false,
      title: "Min. investment",
      img: "/images/product-info/min-inv.png",
      text: "There is no minimum investment required",
    },
    {
      id: "sentimentTracker_4",
      hasChipUI: true,
      isActive: false,
      title: "Benefits for you",
      img: "/images/product-info/benefits.png",
      text: [
        "Short-term profit booking alerts",
        "Personalized stock recommendations",
        "AI-based stock selection",
        "24x7 risk management system",
        "No human bias & error",
      ],
    },
  ],
};

const sentimentTrackerOnboardingStages = [
  {
    stageId: ["PAYMENT"],
    stageNumber: 1,
    heading: "Payment",
    uri: "/sentiment-tracker/onboarding/payment",
    subheading: "payment",
  },
  {
    stageId: ["CKYC", "DOCUMENT_SIGNING"],
    stageNumber: 2,
    heading: "CKYC & E-sign",
    uri: "/sentiment-tracker/onboarding/ckyc",
    subheading: "Complete your KYC",
  },
];
class SentimentTrackerOnboardingNotCompletedContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActivePortfolio: false,
      portfolioKnowMoreSection: true,
      protectKnowMoreSection: false,
      onestockKnowMoreSection: false,
      onestockOpenId: null,
      sentimentTrackerKnowMoreSection: false,
      sentimentTrackerOpenId: null,
    };
  }

  handleTabClick = (data, type) => {
    Tabs[type].forEach((element) => {
      data.id == element.id
        ? (element.isActive = true)
        : (element.isActive = false);
    });
    this.setState({ isActivePortfolio: true });
  };

  handleKnowMore = (type) => {
    const {
      portfolioKnowMoreSection,
      protectKnowMoreSection,
      onestockKnowMoreSection,
      primeKnowMoreSection,
      sentimentTrackerKnowMoreSection,
    } = this.state;
    if (type == "portfolio") {
      this.setState({ portfolioKnowMoreSection: !portfolioKnowMoreSection });
    }
    if (type == "protect") {
      this.setState({ protectKnowMoreSection: !protectKnowMoreSection });
    }
    if (type == "onestock") {
      this.setState({ onestockKnowMoreSection: !onestockKnowMoreSection });
    }
    if (type == "prime") {
      this.setState({ primeKnowMoreSection: !primeKnowMoreSection });
    }
    if (type == "sentimentTracker") {
      this.setState({
        sentimentTrackerKnowMoreSection: !sentimentTrackerKnowMoreSection,
      });
    }
  };

  handleInvestNow = (type) => {
    if (type == "portfolio") {
      localStore.setActiveProduct(config.productCodes.PORTFOLIO);
      this.props.history.push(`/jarvis-portfolio/onboarding/overview`);
    }
    if (type == "protect") {
      localStore.setActiveProduct(config.productCodes.RMS);
      this.props.history.push(`/jarvis-rms/onboarding/overview`);
    }
    if (type == "onestock") {
      localStore.setActiveProduct(config.productCodes.ONESTOCK);
      this.props.history.push(`/jarvis-onestock/onboarding/overview`);
    }
    if (type == "prime") {
      localStore.setActiveProduct(config.productCodes.PRIME);
      this.props.history.push(`/jarvis-prime/onboarding/overview`);
    }
    if (type == "sentimentTracker") {
      localStore.setActiveProduct(config.productCodes.SENTIMENT);
      this.props.history.push(`/sentiment-tracker/onboarding/overview`);
    }
  };

  // For SentimentTracker Steps
  getActiveStageForSentimentTracker = () => {
    const { currentStageForSentimentTracker } = this.props;
    return sentimentTrackerOnboardingStages.find((o) =>
      o.stageId.includes(currentStageForSentimentTracker)
    );
  };

  handleSentimentTrackerTooltip = (id, type = "open") => {
    if (type === "open") {
      this.setState({ sentimentTrackerOpenId: id });
    } else {
      this.setState({ sentimentTrackerOpenId: null });
    }
  };

  render() {
    const { classes } = this.props;
    const { portfolioKnowMoreSection, sentimentTrackerKnowMoreSection } =
      this.state;
    const activeSentimentTrackerStage =
      this.getActiveStageForSentimentTracker();
    let ssoCustomerDetails = localStore.getSsoCustomerDetails();
    let isCentrumSsoCustomer = false;
    if (
      localStore.isSsoCustomer() &&
      ssoCustomerDetails?.broker === config?.broker?.ssoPlatform?.centrum
    ) {
      isCentrumSsoCustomer = true;
    }

    return (
      <Stack mt={3}>
        {/* <Container maxWidth="lg"> */}
        <JarvisCard
          sx={{
            border: "1px solid #d3d3d3",
            position: "relative",
            paddingBottom: "60px",
            marginBottom: "20px",
          }}
        >
          <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
            <Stack sx={{ flex: { xs: "1", md: "2" } }}>
              <Stack direction="row">
                <img
                  src={sentimentTrackerProduct.icon}
                  alt=""
                  style={{ marginRight: "18px" }}
                />
                <div>
                  <Text
                    variant="subtitle1"
                    color={"#2B70C5"}
                    sx={{ fontWeight: 500 }}
                  >
                    {sentimentTrackerProduct.name}
                  </Text>
                  <Text variant="body2" color={"#676E76"}>
                    {sentimentTrackerProduct.description}
                  </Text>
                </div>
              </Stack>
              {/* tab */}
              <Stack
                alignItems="start"
                mt={4}
                direction="row"
                sx={{ overflow: "auto", cursor: "pointer" }}
              >
                {Tabs[sentimentTrackerProduct.id].map((data) => (
                  <Stack
                    direction="column"
                    alignItems="center"
                    sx={{
                      flex: "1 1 auto",
                      minWidth: "125px",
                      borderBottom: data.isActive ? "3px solid #2B70C5" : "",
                    }}
                    onClick={() =>
                      this.handleTabClick(data, `${sentimentTrackerProduct.id}`)
                    }
                  >
                    <img src={data.img} alt="" width={"36px"}></img>
                    <Text variant="body2" mb={1} sx={{ whiteSpace: "noWrap" }}>
                      {data.title}
                    </Text>
                  </Stack>
                ))}
              </Stack>
              <Stack mt={2}>
                {Tabs[sentimentTrackerProduct.id].map((data) => {
                  return !data.isActive ? null : data.hasChipUI ? (
                    <>
                      <Stack
                        direction="row"
                        sx={{
                          flexWrap: "wrap",
                          gap: "0.8rem",
                        }}
                      >
                        {data.text.map((d) => (
                          <Stack className={classes.chipUi}>{d}</Stack>
                        ))}
                      </Stack>
                    </>
                  ) : (
                    <Text variant="body2" color={"#676E76"}>
                      {data.text}
                    </Text>
                  );
                })}
              </Stack>
            </Stack>
            <Stack sx={{ flex: 1 }}>
              <img
                src={sentimentTrackerProduct.banner}
                alt=""
                width={"100%"}
                style={{ marginBottom: "20px" }}
              />
              <JarvisButton
                disableEndIcon={true}
                onClick={() => this.handleInvestNow(sentimentTrackerProduct.id)}
              >
                Invest Now
              </JarvisButton>
            </Stack>
          </Stack>

          {sentimentTrackerProduct.id == "sentimentTracker" &&
          (this.props.currentStageForSentimentTracker === "PAYMENT" ||
            this.props.currentStageForSentimentTracker === "CKYC" ||
            this.props.currentStageForSentimentTracker ===
              "DOCUMENT_SIGNING") ? (
            <ClickAwayListener
              onClickAway={() =>
                this.handleSentimentTrackerTooltip("", "close")
              }
            >
              <Stack
                direction={{ xs: "column", md: "row" }}
                className={classes.toolTipss}
              >
                {this.props.sentimentTrackerOverviewList.map((item, index) => (
                  <Stack
                    mt={4}
                    key={item.id}
                    direction={"row"}
                    alignItems={"center"}
                  >
                    <Chip
                      label={item.id}
                      size="small"
                      sx={{
                        color:
                          item.stageNumber <
                          activeSentimentTrackerStage?.stageNumber
                            ? "white"
                            : "primary.dark",
                        backgroundColor:
                          item.stageNumber <
                          activeSentimentTrackerStage?.stageNumber
                            ? alpha("#2e7d32", 0.8)
                            : alpha("#38a1ff", 0.5),
                        fontWeight: "500",
                        fontSize: {
                          xs: "caption2.fontSize",
                          md: "caption1.fontSize",
                        },
                        maxHeight: "24px",
                        minWidth: "24px",
                      }}
                    />
                    <Text
                      ml={0.5}
                      sx={{
                        fontSize: "14px",
                        color: "#212225",
                        fontWeight: "400",
                      }}
                    >
                      {isCentrumSsoCustomer &&
                      item.name?.toLowerCase() === "ckyc"
                        ? "E-Sign"
                        : item.name}
                    </Text>

                    <TooltipHover
                      title={
                        !isCentrumSsoCustomer
                          ? item.toolTipText
                          : item.toolTipText.replaceAll("CKYC", "E-Sign")
                      }
                      sx={{
                        lineHeight: 0,
                        ml: 0.5,
                        mr:
                          index ===
                          this.props.sentimentTrackerOverviewList.length - 1
                            ? 0
                            : 1.5,
                      }}
                    >
                      <InfoRoundedIcon
                        ml={1}
                        sx={{ width: "20px", color: "#a39e9e" }}
                      />
                    </TooltipHover>
                  </Stack>
                ))}
              </Stack>
            </ClickAwayListener>
          ) : null}

          {sentimentTrackerProduct.id == "sentimentTracker" &&
          sentimentTrackerKnowMoreSection ? (
            <SentimentTrackerInfoContainer />
          ) : null}
          <Button
            className={classes.btns}
            onClick={() => this.handleKnowMore(`${sentimentTrackerProduct.id}`)}
            endIcon={
              sentimentTrackerKnowMoreSection ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )
            }
          >
            {sentimentTrackerProduct.id == "sentimentTracker" &&
            !sentimentTrackerKnowMoreSection
              ? "Know Pricing"
              : "Hide Pricing"}
          </Button>
        </JarvisCard>
        {/* </Container> */}
      </Stack>
    );
  }
}

const style = (theme) => ({
  btns: {
    backgroundColor: "#EEF4FA",
    color: "#2B70C5",
    fontSize: "0.875rem !important",
    fontWeight: 500,
    boxShadow: "none",
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    bborderBottomLeftRadius: "0px",
    bborderBottomRightRadius: "0px",
    textTransform: "capitalize",
    "&:hover": {
      color: "white",
    },
  },
  chipUi: {
    color: "#2B70C5",
    border: "1px solid #DCDCDC",
    padding: "0.25rem 0.5rem",
    fontSize: "12px",
    borderRadius: "24px",
    backgroundColor: "#FFFFFF",
    fontWeight: 500,
  },
});

export default withRouter(
  withStyles(style, { withTheme: true })(
    SentimentTrackerOnboardingNotCompletedContainer
  )
);
